import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.adrLimit'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.adrLimits,
      "filter": _vm.filterItems,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "auto-select-first": "",
      "item-text": "title",
      "item-value": "id",
      "clearable": "",
      "hide-details": ""
    },
    on: {
      "change": function ($event) {
        return _vm.updateData('adr_limit', _vm.formItem.adr_limit);
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item.title))]), _c(VListItemSubtitle, [_vm._v("ID: " + _vm._s(item.id))])], 1)];
      }
    }]),
    model: {
      value: _vm.formItem.adr_limit,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "adr_limit", $$v);
      },
      expression: "formItem.adr_limit"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.tileName'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    on: {
      "change": function ($event) {
        return _vm.updateData('tile_name', _vm.formItem.tile_name);
      }
    },
    model: {
      value: _vm.formItem.tile_name,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "tile_name", $$v);
      },
      expression: "formItem.tile_name"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VSelect, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.operationalStatus'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.operationalStatus,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "return-object": "",
      "item-text": "text",
      "item-value": "value",
      "clearable": "",
      "hide-details": ""
    },
    on: {
      "change": function ($event) {
        return _vm.updateData('properties.operational_status', _vm.formItem.properties.operational_status);
      }
    },
    model: {
      value: _vm.formItem.properties.operational_status,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "operational_status", $$v);
      },
      expression: "formItem.properties.operational_status"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.operationalStatusHint')))])], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.threshold'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "type": "number",
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    on: {
      "change": function ($event) {
        return _vm.updateData('properties.minimum_packets_threshold', _vm.formItem.properties.minimum_packets_threshold);
      }
    },
    model: {
      value: _vm.formItem.properties.minimum_packets_threshold,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "minimum_packets_threshold", $$v);
      },
      expression: "formItem.properties.minimum_packets_threshold"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.thresholdHint')))])], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.warningLevel'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "type": "number",
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    on: {
      "change": function ($event) {
        return _vm.updateData('properties.battery_warning_level', _vm.formItem.properties.battery_warning_level);
      }
    },
    model: {
      value: _vm.formItem.properties.battery_warning_level,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "battery_warning_level", $$v);
      },
      expression: "formItem.properties.battery_warning_level"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.warningLevelHint')))])], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.alertLevel'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "type": "number",
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    on: {
      "change": function ($event) {
        return _vm.updateData('properties.battery_alert_level', _vm.formItem.properties.battery_alert_level);
      }
    },
    model: {
      value: _vm.formItem.properties.battery_alert_level,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "battery_alert_level", $$v);
      },
      expression: "formItem.properties.battery_alert_level"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.alertLevelHint')))])], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.maxIdleTime'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "type": "number",
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    on: {
      "change": function ($event) {
        return _vm.updateData('properties.critical_time_without_package_level.time', _vm.formItem.properties.critical_time_without_package_level.time);
      }
    },
    model: {
      value: _vm.formItem.properties.critical_time_without_package_level.time,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties.critical_time_without_package_level, "time", $$v);
      },
      expression: "formItem.properties.critical_time_without_package_level.time"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.maxIdleTimeHint')))])], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c(VSelect, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.timeUnits'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.timeUnits,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "return-object": "",
      "item-text": "text",
      "item-value": "value",
      "clearable": "",
      "hide-details": ""
    },
    on: {
      "change": function ($event) {
        return _vm.updateData('properties.critical_time_without_package_level.unit', _vm.formItem.properties.critical_time_without_package_level.unit);
      }
    },
    model: {
      value: _vm.formItem.properties.critical_time_without_package_level.unit,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties.critical_time_without_package_level, "unit", $$v);
      },
      expression: "formItem.properties.critical_time_without_package_level.unit"
    }
  })], 1), _vm.showStatics ? _c(VCol, {
    staticClass: "pt-0 mx-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.detailViewOptions')) + "\n    "), _c(VRow, [_c(VCol, {
    staticClass: "my-0 mx-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VCheckbox, {
    staticClass: "shrink mx-0 my-0",
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.statistics'),
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "hide-details": ""
    },
    on: {
      "change": function ($event) {
        return _vm.updateData('properties.enable_statistics', _vm.formItem.properties.enable_statistics);
      }
    },
    model: {
      value: _vm.formItem.properties.enable_statistics,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "enable_statistics", $$v);
      },
      expression: "formItem.properties.enable_statistics"
    }
  })], 1), _c(VCol, {
    staticClass: "my-0 mx-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VCheckbox, {
    staticClass: "shrink mx-0 my-0",
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.sfGraph'),
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "hide-details": ""
    },
    on: {
      "change": function ($event) {
        return _vm.updateData('properties.enable_SFGraph', _vm.formItem.properties.enable_SFGraph);
      }
    },
    model: {
      value: _vm.formItem.properties.enable_SFGraph,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "enable_SFGraph", $$v);
      },
      expression: "formItem.properties.enable_SFGraph"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.showDeviceType ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.deviceType'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.deviceTypes,
      "filter": _vm.filterItems,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "auto-select-first": "",
      "item-text": "title",
      "item-value": "id",
      "clearable": "",
      "hide-details": ""
    },
    on: {
      "change": function ($event) {
        return _vm.updateData('deviceTypeId', _vm.formItem.deviceTypeId);
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item.title))]), _c(VListItemSubtitle, [_vm._v("ID: " + _vm._s(item.id))])], 1)];
      }
    }], null, false, 2098911049),
    model: {
      value: _vm.formItem.deviceTypeId,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "deviceTypeId", $$v);
      },
      expression: "formItem.deviceTypeId"
    }
  })], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };